exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".XAxisTicks--tick--OEdi5{stroke:var(--axis-tick)}", ""]);

// exports
exports.locals = {
	"tick": "XAxisTicks--tick--OEdi5"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/common/XAxisTicks.css
 ** module id = 172
 ** module chunks = 0
 **/